var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagFinishIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.968,
    height: 30.89,
    viewBox: "0 0 14.968 30.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1144",
    "data-name": "Trazado 1144",
    d: "M43.3,9a1.159,1.159,0,0,0,.172-.607V8.223A1.183,1.183,0,0,0,42.284,7.04H29.656c-.235,0,.663.26.4.192V6.78a.78.78,0,1,0-1.56,0V36.111a.78.78,0,0,0,1.56,0V18.381c-.26-.164-.5.192-.26.192H42.235a1.224,1.224,0,0,0,1.118-.652,1.162,1.162,0,0,0-.037-1.079L41.15,13.062a.587.587,0,0,1,.01-.6Z",
    transform: "translate(-28.5 -6)",
    fill: "#ffb400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFinishIcon);
export default __webpack_public_path__ + "static/media/flagFinishIcon.cf1ff94257636b1b20f0b658d2c011b7.svg";
export { ForwardRef as ReactComponent };